
import { Box, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState, useRef, useEffect } from "react";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};
const style1 = {
    paddingTop: '11px',
    paddingBottom: '12px'
}
const ConfirmModal = (props) => {

    useEffect(() => {

    }, []);


    return (
        <>
            {/* Delete Modal */}
            <Modal
                open={props?.isConfirmModalOpen}
                onClose={props.closeConfirmModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={style}
                    className="modal_react_controlpanel_employee MuiBox-root css-1wnsr1i"
                >
                    <div className="modal-header" style={{ borderBottom: 'none' }}>
                        <h5 className="modal-title" id="exampleModalLabel"></h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={props.closeConfirmModal}
                        ></button>
                    </div>

                    <div className="modal-body lets_list_cotegory_status_management_block_bodyP">
                        <p className="lets_want_changes_delete_icon">
                            <b>{(props?.status === 'ApproveAndPublish') ? 'Approve and Publish' : props?.status} RFQ</b>
                            {props?.status === 'Approve' &&
                                <p style={style1}>On Approval of this RFQ, the bidding process will be initiated.</p>
                            }
                            {props?.status === 'Publish' &&
                                <p style={style1}>On publishing this RFQ, an invite will be shared to respective vendors.</p>
                            }
                            {props?.status === 'Cancel' &&
                                <p style={style1}>On closing of this RFQ, the RFQ will no longer be open for bidding.</p>
                            }
                            {props?.status === 'ApproveAndPublish' &&
                                <p style={style1}>On Approval of this RFQ, the bidding process will be initiated & invite will be published to respective Vendors.</p>
                            }

                        </p>
                        <p className="lets_want_changes_delete_icon" style={style1}>
                            {props?.modalMsg}
                        </p>

                        <button
                            type="button"
                            className="btn clear_btn"
                            data-bs-dismiss="modal"
                            onClick={props.closeConfirmModal}
                        >
                            {props.closeText ? props.closeText : 'No'}

                        </button>
                        <Button
                            type="button"
                            className="btn btn-success save_next_btn"
                            onClick={props.successConfirmModal}
                        >
                            Yes
                        </Button>
                    </div>
                </Box>
            </Modal>
        </>
    );
};

export default ConfirmModal;